import type { CompletionToastVariant } from '@/components/CompletionToast/utils'

import { ActionSection, FooterSection, HeroSection, MissionSection, NoticeSection, RewardSection } from './components'
import { BottomArea, Container, GradientArea } from './styles'

interface CouponStepProps {
  onDraw: () => void
  onQuiz: () => void
  coinBalance: number
  isCoinLoading: boolean
  isDrawing: boolean
  onMissionComplete?: (type: CompletionToastVariant) => void
}

export default function CouponStep({
  onDraw,
  onQuiz,
  coinBalance,
  isCoinLoading,
  isDrawing,
  onMissionComplete,
}: CouponStepProps) {
  const isDisabled = coinBalance === 0

  return (
    <Container>
      <GradientArea>
        <HeroSection isDisabled={isDisabled} />
      </GradientArea>
      <BottomArea>
        <ActionSection onDraw={onDraw} coinBalance={coinBalance} isCoinLoading={isCoinLoading} isDrawing={isDrawing} />
        <MissionSection onQuiz={onQuiz} onMissionComplete={onMissionComplete} />
        <RewardSection />
        <FooterSection />
      </BottomArea>
      <NoticeSection />
    </Container>
  )
}
